<app-header [class.dark]="!gallery || !!gallery.cover.uuid" [small]="true">
  <a
    appButton
    name="back-to-parent"
    class="back-button"
    location="view-gallery-header"
    color="default-opacity"
    [iconButton]="true"
    appTooltip="Back"
    shape="round"
    height="1"
    [routerLink]="parentLink"
    *ngIf="parentLink"
  >
    <app-svg src="/assets/icons/arrow-left.svg" size="0-5"></app-svg>
  </a>
  <app-context-menu [options]="{ width: '480px', noSpacing: true }" #treeMenu *ngIf="showGalleriesButton">
    <button
      appButton
      contextButton
      name="galleries"
      location="view-gallery-header"
      shape="round"
      color="default-opacity"
      appTooltip="Show Galleries"
      height="1"
      size="1"
      [hasIcon]="!isMobile"
      [iconButton]="isMobile"
      weight="bold"
    >
      <app-svg src="/assets/icons/menu-list.svg" size="0-5"></app-svg>
      <span *ngIf="!isMobile">Galleries</span>
    </button>
    <div contextContent>
      <app-gallery-tree
        [gallery]="gallery"
        *ngIf="treeMenu.isOpen"
        [clientMode]="true"
        (onClose)="treeMenu.close()"
      ></app-gallery-tree>
    </div>
  </app-context-menu>

  <div class="spacer"></div>

  <app-context-menu
    [options]="{ width: '240px', noSpacing: true }"
    #statusMenu
    *ngIf="
      accessLevel !== 'view_only' && gallery?.enabled_gallery_statuses.length > 1 && featureFlags.get('galleryStatus')
    "
  >
    <button
      appButton
      contextButton
      name="gallery-status"
      location="view-gallery-header"
      data-test-id="gallery-status"
      shape="round"
      color="default-opacity"
      class="gallery-status-button"
      appTooltip="Gallery Status"
      height="1"
      size="1"
      [hasIcon]="!isMobile"
      [iconButton]="isMobile"
      weight="bold"
    >
      <app-svg
        src="/assets/icons/{{ gallery?.status | galleryStatusIcon }}.svg"
        [attr.color]="gallery?.status | galleryStatusColor"
      ></app-svg>
      <app-svg *ngIf="!isMobile" src="/assets/icons/12/chevron-down.svg" size="-2"></app-svg>
    </button>
    <app-gallery-status-context
      contextContent
      [gallery]="gallery"
      (onSelectStatus)="updateGalleryStatus($event); statusMenu.close()"
    ></app-gallery-status-context>
  </app-context-menu>

  <a
    [routerLink]="['./advanced']"
    appButton
    name="advanced-mode"
    color="default-opacity"
    location="view-gallery-header"
    data-test-id="view-advanced-mode"
    [hasIcon]="!isMobile"
    [iconButton]="isMobile"
    shape="round"
    height="1"
    size="1"
    weight="bold"
    appTooltip="Switch to Advanced Mode"
    *ngIf="allowAdvancedMode && mode === 'layout'"
  >
    <app-svg src="/assets/icons/search-menu.svg" size="0-5"></app-svg>
    <span *ngIf="!isMobile">{{ 'am-button' | translate }}</span>
  </a>

  <a
    [routerLink]="['../']"
    appButton
    name="layout"
    color="default-opacity"
    location="view-gallery-header"
    data-test-id="view-layout-mode"
    [hasIcon]="!isMobile"
    [iconButton]="isMobile"
    shape="round"
    height="1"
    size="1"
    weight="bold"
    appTooltip="Switch to Layout"
    *ngIf="allowAdvancedMode && mode === 'advanced'"
  >
    <app-svg src="/assets/icons/gallery-stand.svg" size="0-5"></app-svg>
    <span *ngIf="!isMobile">Layout</span>
  </a>

  <app-view-filter
    [gallery]="gallery"
    [accessLevel]="accessLevel"
    (onFilterChange)="onFilter($event)"
    *ngIf="accessLevel !== 'view_only' && !allowAdvancedMode && mode === 'layout'"
    #viewFilter
  >
  </app-view-filter>

  <app-context-menu
    [options]="{ width: '240px', noSpacing: true }"
    #downloadMenu
    *ngIf="gallery?.download_full_gallery"
  >
    <button
      appButton
      name="download-all"
      color="default-opacity"
      location="view-gallery-header"
      data-test-id="download-gallery"
      class="download-button"
      shape="round"
      height="1"
      size="1"
      [iconButton]="true"
      weight="bold"
      [hideTextOnMobile]="allowAdvancedMode"
      appTooltip="Download All"
      toolTipOrigin="top-right"
      contextButton
    >
      <app-svg src="/assets/icons/download.svg" size="0-5"></app-svg>
      <!-- <span *ngIf="!downloadingAll && !preppingDownloadAll">{{ 'download-all-button' | translate }}</span>
      <span *ngIf="preppingDownloadAll">{{ 'download-all-button-clicked' | translate }}</span>
      <span *ngIf="downloadingAll">{{ 'download-all-button-downloading' | translate }}</span> -->
    </button>

    <div class="button-menu" contextContent>
      <app-gallery-download-menu-options
        [gallery]="gallery"
        [includeSubGalleries]="true"
        (onDownload)="download($event); downloadMenu.close()"
        *ngIf="downloadMenu.isOpen"
      >
      </app-gallery-download-menu-options>
    </div>
  </app-context-menu>

  <app-context-menu
    [options]="{ width: '320px', noSpacing: true }"
    name="view-gallery context"
    #menu
    *ngIf="state.user || state.guest?.email"
  >
    <div
      contextButton
      class="profile-circle"
      [appTooltip]="(state.user || state.guest | userGuestName) + ' (you)'"
      toolTipOrigin="top-right"
      [class.auto-border]="state.user?.avatar_url"
    >
      <app-avatar [user]="state.user || state.guest"></app-avatar>
    </div>
    <app-view-profile-menu
      [accessLevel]="accessLevel"
      [gallery]="gallery"
      contextContent
      (onClose)="menu.close()"
    ></app-view-profile-menu>
  </app-context-menu>

  <div
    class="profile-circle"
    [appTooltip]="(state.guest | userGuestName) + ' (you)'"
    toolTipOrigin="top-right"
    (click)="openGuestProfileDialog()"
    *ngIf="
      !state.user && !state.guest?.email && accessLevel !== 'view_only' && enabledAndAllowedFeedbackOptions?.length > 0
    "
  >
    <app-avatar [user]="state.guest"></app-avatar>
  </div>
</app-header>
